import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Lux Sensor Icon Style 02 - Sunny (Material Symbol)
 */
export const Style02_Sunny: React.FC<DeviceIconProps> = ({
  isOn = true,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-yellow-500' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      sunny
    </span>
  );
};

export default Style02_Sunny;
